import React from 'react';
import { Card } from '@/components/ui/card';
import { Link } from 'react-router-dom';
import { ArrowLeft, Shield } from 'lucide-react';

const Privacy = () => (
  <div className="min-h-screen bg-[#F4F6F8] p-4 md:p-8">
    <div className="max-w-3xl mx-auto space-y-6">
      <Link to="/" className="flex items-center gap-2 text-sm text-[#475569] hover:text-[#1E3A5F]">
        <ArrowLeft className="w-4 h-4" /> Voltar ao Tô de Olho
      </Link>

      <Card className="p-6 md:p-8 bg-white border border-[#E2E8F0] rounded-md">
        <div className="flex items-center gap-3 mb-6">
          <Shield className="w-6 h-6 text-[#1E3A5F]" />
          <h1 className="text-2xl font-black text-[#0F1C2E]">Política de Privacidade</h1>
        </div>
        <p className="text-xs text-[#94A3B8] mb-6">Última atualização: abril de 2026</p>

        <div className="prose prose-sm max-w-none text-[#475569] space-y-4">
          <h2 className="text-lg font-bold text-[#0F1C2E]">1. Introdução</h2>
          <p>O Tô de Olho ("nós", "nosso") é um aplicativo de análise de integridade de candidatos políticos. Esta política descreve como tratamos as informações ao utilizar nosso serviço.</p>

          <h2 className="text-lg font-bold text-[#0F1C2E]">2. Dados que Coletamos</h2>
          <p><strong>Não coletamos dados pessoais dos usuários.</strong> O Tô de Olho não requer cadastro, login ou qualquer informação pessoal para funcionar.</p>
          <p>Os únicos dados armazenados são:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Análises de candidatos geradas pelo usuário (nome do candidato, cargo, estado)</li>
            <li>Lista de candidatos monitorados</li>
            <li>Notificações de mudanças detectadas</li>
          </ul>
          <p>Estes dados são armazenados no servidor e não estão vinculados a nenhuma identidade pessoal.</p>

          <h2 className="text-lg font-bold text-[#0F1C2E]">3. Fontes de Dados</h2>
          <p>As análises são baseadas em:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Dados públicos do Tribunal Superior Eleitoral (TSE)</li>
            <li>Informações de tribunais (STF, STJ)</li>
            <li>Fontes de mídia pública</li>
            <li>Análise por inteligência artificial (OpenAI GPT-5.2)</li>
          </ul>

          <h2 className="text-lg font-bold text-[#0F1C2E]">4. Uso de Inteligência Artificial</h2>
          <p>Utilizamos inteligência artificial para gerar análises estruturadas. A IA pode cometer erros. As análises não substituem verificação própria e não constituem aconselhamento legal ou político.</p>

          <h2 className="text-lg font-bold text-[#0F1C2E]">5. Compartilhamento de Dados</h2>
          <p>Não vendemos, compartilhamos ou transferimos dados para terceiros. Links de compartilhamento público são gerados apenas quando o usuário solicita explicitamente.</p>

          <h2 className="text-lg font-bold text-[#0F1C2E]">6. Segurança</h2>
          <p>Todas as comunicações são criptografadas via HTTPS. Os dados são armazenados em servidores seguros com acesso restrito.</p>

          <h2 className="text-lg font-bold text-[#0F1C2E]">7. Seus Direitos</h2>
          <p>Como não coletamos dados pessoais, não há dados pessoais a serem acessados, corrigidos ou excluídos. Você pode limpar o histórico de análises a qualquer momento dentro do aplicativo.</p>

          <h2 className="text-lg font-bold text-[#0F1C2E]">8. Contato</h2>
          <p>Para dúvidas sobre esta política, entre em contato: suporte@todeolho.app</p>

          <h2 className="text-lg font-bold text-[#0F1C2E]">9. Alterações</h2>
          <p>Esta política pode ser atualizada periodicamente. Alterações significativas serão comunicadas dentro do aplicativo.</p>
        </div>
      </Card>
    </div>
  </div>
);

export default Privacy;
